import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import ImgDrafts from '../../../../../assets/images/dashboard/UpgradePremiumMoreThanThree.png';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { SET_MODAL_STATUS, SET_MODAL_TYPE } from 'store/actions';
import { setModalOpen } from 'store/ResponseTemplate/actions';

const UpgradePremiumMoreThanThreeQuestion = () => {
    const navigate = useNavigate();
    const { companyCreator } = useSelector((state) => state.authentication);
    const dispatch = useDispatch();
    const upgradePlan = () => {
        if (!companyCreator) {
            dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
            dispatch({ type: SET_MODAL_TYPE, modalType: 'non_permit_upgrade' });
            return;
        }
        dispatch({ type: setModalOpen, modalOpen: false });
        navigate('/dashboard/update-plan');
    };
    return (
        <>
            <Stack
                gap={4}
                // className="premium-question-card"
                alignItems="center"
                justifyContent="center"
                sx={{
                    flexDirection: { xs: 'column', md: 'row' },
                    width: '100%'
                }}
                columnGap={3}
            >
                <Stack gap={3} alignItems="flex-start" width={{ xs: '100%', md: '60%' }}>
                    <Stack gap={3} alignItems="flex-start">
                        <Typography
                            component="span"
                            sx={{
                                display: 'flex',
                                fontSize: '0.875rem',
                                backgroundColor: 'rgba(0, 33, 77, 0.20)',
                                gap: '8px',
                                padding: '8px',
                                borderRadius: '50px',
                                color: '#00214D',
                                svg: {
                                    width: '16px',
                                    height: '16px',
                                    path: {
                                        fill: '#00214D'
                                    }
                                }
                            }}
                        >
                            <DiamondOutlinedIcon />
                            Premium
                        </Typography>
                        <Typography
                            component="h2"
                            color="#212121"
                            fontFamily="poppins"
                            fontSize="1.5rem"
                            lineHeight="1.3334"
                            fontWeight="600"
                        >
                            Upgrade to add unlimited questions
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            component="p"
                            color="rgba(50, 52, 56, 0.60)"
                            fontSize="1.25rem"
                            lineHeight="1.6"
                            fontWeight="400"
                        >
                            You have exceeded the limit of 3 questions included within your plan.
                        </Typography>
                    </Stack>
                    <Button className="alternate" onClick={upgradePlan}>
                        Upgrade
                    </Button>
                </Stack>
                <Stack width={{ xs: '100%', md: '40%' }} justifyContent="center" alignItems="center">
                    <img src={ImgDrafts} alt="questions" width="225" height="237" />
                </Stack>
            </Stack>
        </>
    );
};

export default UpgradePremiumMoreThanThreeQuestion;
